import {NGXLogger} from "ngx-logger";

export class VerifyAnswer {
    constructor(public id: number,
                public answer: string,
                private logger: NGXLogger)
      { }
  }
